import React from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function VisitOurJeffersonHq() {
  return <section data-section-id="131119" id="our-local-office" className="bg-background py-16 lg:py-24 border-t-2 border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="relative group">
            <div className="absolute -inset-1 bg-primary/10 blur-2xl rounded-sm opacity-40 group-hover:opacity-60 transition-opacity duration-500"></div>
            <div className="relative border border-border rounded-sm overflow-hidden bg-card shadow-lg">
              <AspectRatio ratio={4 / 3} className="bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615668/img/crawl_space_repair_des_moines.png" alt="Our Des Moines Service Headquarters" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
              </AspectRatio>
              {}
              <div className="absolute bottom-0 left-0 w-full h-1.5 bg-secondary"></div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8">

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {}
              <Card className="border border-border bg-card/40 hover:bg-card transition-colors rounded-sm">
                <CardContent className="p-6 flex flex-col gap-4">
                  <div className="p-3 bg-primary/5 w-fit rounded-sm border border-primary/10">
                    <MapPin className="size-6 text-primary" />
                  </div>
                  <div>
                    
                    <p className="text-muted-foreground mt-1 leading-relaxed font-sans">
                      Des Moines, Iowa<br />
                      <span className="text-xs font-mono uppercase tracking-wider text-primary/70">Serving Greater Des Moines</span>
                    </p>
                  </div>
                </CardContent>
              </Card>

              {}
              <Card className="border border-border bg-card/40 hover:bg-card transition-colors rounded-sm">
                <CardContent className="p-6 flex flex-col gap-4">
                  <div className="p-3 bg-primary/5 w-fit rounded-sm border border-primary/10">
                    <Clock className="size-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-foreground text-lg font-sans">Office Hours</h3>
                    <p className="text-muted-foreground mt-1 leading-relaxed font-sans">
                      Mon – Fri: 7:30 AM – 5:30 PM<br />
                      <span className="text-xs font-mono uppercase tracking-wider text-primary/70">Sat: By Appointment</span>
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>

            <Separator className="bg-border/40 h-[1px]" />

            {}
            <div className="flex flex-col gap-4">
              <Button asChild size="lg" className="w-full h-20 sm:h-24 text-xl sm:text-2xl font-bold bg-secondary hover:bg-secondary/90 text-secondary-foreground border-none shadow-2xl shadow-secondary/30 ring-2 ring-secondary/50 transition-all hover:scale-105 transition-transform justify-start px-6 sm:px-8 rounded-sm">
                <Link to="tel:5155859542">
                  <div className="bg-white/10 p-2 rounded-sm mr-4">
                    <Phone className="size-7 sm:size-10" />
                  </div>
                  <span className="flex flex-col items-start font-sans">
                    <span className="text-xs sm:text-sm font-mono font-medium opacity-90 uppercase tracking-widest">Request a Free inspection</span>
                    <span>(515) 585-9542</span>
                  </span>
                </Link>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>;
}